import { render, staticRenderFns } from "./fiatCurrencyBuyNft.vue?vue&type=template&id=4a5c5db2&scoped=true&"
import script from "./fiatCurrencyBuyNft.vue?vue&type=script&lang=js&"
export * from "./fiatCurrencyBuyNft.vue?vue&type=script&lang=js&"
import style0 from "../css/fiatCurrencyBuyNft.scss?vue&type=style&index=0&id=4a5c5db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c5db2",
  null
  
)

export default component.exports